import { render, staticRenderFns } from "./orderLineItem.vue?vue&type=template&id=237c4dd6&scoped=true"
import script from "./orderLineItem.vue?vue&type=script&lang=js"
export * from "./orderLineItem.vue?vue&type=script&lang=js"
import style0 from "./orderLineItem.vue?vue&type=style&index=0&id=237c4dd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237c4dd6",
  null
  
)

export default component.exports